import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=26f3832a&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=26f3832a&prod&lang=scss&"
import style1 from "./feedBack.vue?vue&type=style&index=1&id=26f3832a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3832a",
  null
  
)

export default component.exports